module.exports = __webpack_public_path__ + "static/media/ICON-logo.8b7cdbd8.png";